<template>
    <b-card title="Filters">
        <b-container fluid>
            <b-row>
                <b-col>
                    <b-form-group
                        id="fieldset-customer"
                        label="Customer"
                        label-for="input-officer"
                    >
                        <customer-type-ahead
                            v-model="filtersModel.customer_id"
                        />
                    </b-form-group>
                </b-col>

                <b-col>
                    <b-form-group
                        id="fieldset-default-engineer-id"
                        label="Agent"
                        label-for="input-default-engineer-id"
                    >
                        <b-form-select
                            id="input-default-engineer-id"
                            v-model="filtersModel.default_engineer_id"
                            value-field="id"
                            text-field="name"
                            :options="officers"
                        >
                            <template #first>
                                <b-form-select-option :value="null"
                                    >Any Officer</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group
                        id="fieldset-role-id"
                        label="Roles"
                        label-for="role-id"
                    >
                        <b-form-select
                            id="input-role-id"
                            v-model="filtersModel.role_id"
                            value-field="id"
                            text-field="name"
                            :options="roles"
                        >
                            <template #first>
                                <b-form-select-option :value="null"
                                    >Select Role</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>


                <b-col>
                    <b-form-group
                        id="fieldset-assetType"
                        label="Type"
                        label-for="input-assetType"
                    >
                        <b-form-select
                            id="input-assetType"
                            v-model="filtersModel.type_id"
                            value-field="id"
                            text-field="name"
                            :options="types"
                            :disabled="crm"
                        >
                            <template #first>
                                <b-form-select-option :value="null"
                                    >Any Type</b-form-select-option
                                >
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="!crm">
                <b-col>
                    <b-form-group
                        id="fieldset-warranty_from"
                        label="Warranty From"
                        label-for="input-warranty_from"
                    >
                        <b-form-input
                            type="date"
                            id="input-warranty_from"
                            v-model="filtersModel.warranty_from"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col>
                    <b-form-group
                        id="fieldset-warranty_to"
                        label="Warranty To"
                        label-for="input-warranty_to"
                    >
                        <b-form-input
                            type="date"
                            id="input-warranty_to"
                            v-model="filtersModel.warranty_to"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-form-group
                        id="fieldset-last_service_from"
                        label="Last Service From"
                        label-for="input-last_service_from"
                    >
                        <b-form-input
                            type="date"
                            id="input-last_service_from"
                            v-model="filtersModel.last_service_from"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col>
                    <b-form-group
                        id="fieldset-last_service_to"
                        label="Last Service To"
                        label-for="input-last_service_to"
                    >
                        <b-form-input
                            type="date"
                            id="input-last_service_to"
                            v-model="filtersModel.last_service_to"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-form-group
                        id="fieldset-next_service_from"
                        label="Next Service From"
                        label-for="input-next_service_from"
                    >
                        <b-form-input
                            type="date"
                            id="input-next_service_from"
                            v-model="filtersModel.next_service_from"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col>
                    <b-form-group
                        id="fieldset-next_service_to"
                        label="Next Service To"
                        label-for="input-next_service_to"
                    >
                        <b-form-input
                            type="date"
                            id="input-next_service_to"
                            v-model="filtersModel.next_service_to"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>
    </b-card>
</template>

<script>
import CustomerTypeAhead from '@/components/CustomerTypeAhead'

export default {
    name: 'assets-reportQueryBuilder',
    components: { CustomerTypeAhead },
    data: () => ({}),
    props: ['value', 'types', 'crm', 'officers','roles'],

    computed: {
        filtersModel: {
            // getter
            get() {
                return this.value
            },
            // setter
            set(val) {
                this.$emit('input', val)
            },
        },
    },

    watch: {},
}
</script>
